// src/layout/header.tsx

import React, { useEffect, useState } from "react";
import { useLocation, NavLink } from "react-router-dom";
import FreyrFusion from "../assets/images/FreyaFusion-Logo.png";
import { useVersionContext } from "../context/VersionContext";
import { getVersions } from "../versions/versionRegistry";

type ThemeType = "light" | "dark" | "orange";

const Header: React.FC = () => {
  const { currentVersion, setCurrentVersion } = useVersionContext();
  const pathname = useLocation().pathname;
  const versions = getVersions();

  const [theme, setTheme] = useState<ThemeType>("light");
  
  // Get components from version registry
  const pages = currentVersion.pages;

  // Filter available components for this version
  const availablePages = pages.filter(
    (page) => page.availableIn.includes(currentVersion.id)
  );

  // Apply saved theme on load
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") as ThemeType;

    if (savedTheme) {
      setTheme(savedTheme);
      applyTheme(savedTheme);
    }
  }, []);

  // ✅ Apply Theme (clean + scalable)
    const applyTheme = (selectedTheme: ThemeType) => {
    const body = document.body;

    // Remove all theme classes first
    body.classList.remove("light-theme", "dark-theme", "orange-theme");

    // Add selected theme
    body.classList.add(`${selectedTheme}-theme`);
  };

  const handleThemeChange = (value: ThemeType) => {
    setTheme(value);
    applyTheme(value);
    localStorage.setItem("theme", value);
  };

  return (
    <header>
      <div className="maincontainer">
        <div className="logospace">
          <a href="/">
            <img title="Logo" src={FreyrFusion} className="logo" alt="Logo" />
          </a>
          <select
            className="muiversion"
            onChange={(e) => setCurrentVersion(e.target.value)}
            value={currentVersion.id}
          >
            {versions.map((v) => (
              <option key={v.id} value={v.id}>
                {v.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    
      <nav>
        <ul>


          {availablePages.map((page) => (
            <li key={page.path}>
              <NavLink
                to={`${page.path}`}
                className={({ isActive }) => (isActive ? "navactive" : "")}
              >
                {page.name}

              </NavLink>
            </li>
          ))}
                    
          
        </ul>
      </nav>
      <div className="theme-section">
          <select value={theme} onChange={(e) => handleThemeChange(e.target.value as ThemeType)}>
            <option value="light">Light</option>
            <option value="dark">Dark</option>
            <option value="orange">Orange</option>
          </select>
      </div>
    </header>
  );
};

export default Header;
